import React, { useState } from 'react'
import { Modal, Button, ModalBody, ModalHeader } from 'reactstrap'
import { useDispatch, flashSuccess, flashError } from "@/shared/components/flash"
import axios from 'axios'
import "./style.scss";

const ResendInviteModal = ({ isOpen, toggle, selectedRows, program, setTrigger }) => {
    const dispatch = useDispatch()
    const [saving, setSaving] = useState(false);

    const onSubmit = values => {
        let formData = {
            recipients: selectedRows.map((item) => item.id)
        }

        setSaving(true)

        axios.post(`/organization/${program.organization_id}/program/${program.id}/inviteResend`, formData)
            .then((res) => {
                if (res.status == 200) {
                    setTrigger(Math.floor(Date.now() / 1000))
                    flashSuccess(dispatch, 'Participants re-invited successfully!')
                    setSaving(false)
                    toggle()
                    // window.location.reload()
                }
            })
            .catch((err) => {
                flashError(dispatch, err.response.data)
                setSaving(false)
            });
    }

    return (
        <Modal className={`modal-action manager-program-modal modal-lg`} isOpen={isOpen} toggle={toggle}>
            <ModalHeader tag="div" className="manager-program-modal__header manager-program-action-modal__header">
                <h3 className="manager-program-action-modal__title">Resend Invitation</h3>
                <button
                    type="button"
                    className="manager-program-action-modal__close"
                    aria-label="Close"
                    onClick={toggle}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body manager-program-action-modal__body">
                {saving && <p className="manager-program-action-modal__status">Resending invitation, please wait...</p>}
                <div className="manager-program-action-modal__section">
                    <h4 className="manager-program-action-modal__section-title">Participant List to be Invited</h4>
                    <ul className="manager-program-action-modal__list">
                        {selectedRows.map((item, index) => (
                            <li key={index} className="manager-program-action-modal__list-item">
                                <strong>{item.last_name}, {item.first_name}</strong>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="manager-program-action-modal__footer">
                    <Button
                        className="manager-program-action-modal__action manager-program-action-modal__action--primary"
                        disabled={saving}
                        onClick={onSubmit}
                    >
                        Resend Invitation
                    </Button>
                    <Button type="button" className="manager-program-action-modal__action" onClick={toggle}>
                        Cancel
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}


export default ResendInviteModal;
